/**
 * 复制文本到粘贴板
 * @param text
 * @returns {boolean}
 */
export function copyText(text=""){
  if(typeof text !== "string"){
    if(typeof text !== 'undefined' && typeof text.toString === "function") text = text.toString();
    else  return false;
  }
  if(text.length === 0) return false;
  const id = "copyTargetInput";
  let $input = document.getElementById(id);
  if(!$input){
    $input = document.createElement("input");
    $input.setAttribute("id",id);
    $input.setAttribute("type","text");
    const style = {
      opacity:"0",
      width:"1px",
      height:"1px",
      position:"fixed",
      bottom:"-10px",
      right:"-10px",
    }
    for (const styleKey in style) {
      $input.style[styleKey] = style[styleKey];
    }
  }
  document.body.append($input);
  $input.value = text;
  $input.select()
  return document.execCommand("copy");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/my-tools-kit/src/modules/copy.js
// module id = null
// module chunks = 